"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CheckboxField", {
  enumerable: true,
  get: function get() {
    return _CheckboxField["default"];
  }
});
exports["default"] = void 0;

var _CheckboxField = _interopRequireWildcard(require("../CheckboxField"));

/**
 * DEPRECATED - only exists for backwards compatibility
 */
var _default = _CheckboxField.Checkbox;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Form/Checkbox.js
// module id = 486
// module chunks = 0